export default __webpack_public_path__ + "static/media/TulsaPythonistasLogo.9bb5a30d.png";